import * as React from 'react';
import Button from '../../../common/Button';
import { goToCheckout } from 'src/utils/navigation';
import i18n from 'src/translation/i18n';

interface ICheckoutSummaryProps {
  subtotal: string;
  itemCount: number;
  areThereInvalidQtys: boolean;
  updating: boolean;
  hardCreditHold: string;
  isCheckOutAllowed: boolean;
}

const CheckoutSummary = (props: ICheckoutSummaryProps) => {
  return (
    <section className="elevation-2 cart-view--checkout-summary">
      {props.updating ? (
        <section className="checkout-view--items-section--disable" />
      ) : (
        ''
      )}
      <Button
        label={`${i18n.t('common.checkout')} (${props.itemCount} items)`}
        buttonClass="primary-button checkout-button"
        action={goToCheckout}
        disabled={props.itemCount === 0 || props.areThereInvalidQtys || props.hardCreditHold==="HARD_STOP" || props.isCheckOutAllowed===false}
      />
      <div className="row total-row">
        <div className="col">{i18n.t('common.orderSubtotal')}</div>
        <div className="col total-price">${props.subtotal}</div>
      </div>
    </section>
  );
};

export default CheckoutSummary;
